import React from 'react';
import { Outlet } from 'react-router-dom';

/** Renders nested admin profile routes (Mon profil, Sauvegardes, …) */
const AdminProfileOutlet = () => <Outlet />;

export default AdminProfileOutlet;
